import { Combobox } from '@opendoor/atoms/combobox';
import type { ComboboxOption } from '@opendoor/atoms/combobox';
import {
  isListingSortSlug,
  listingSortOptions,
  type ListingSortSlug,
} from 'components/marketplace/helpers/sortOptions';

interface ListingSortControlProps {
  /** Currently applied sort slug. */
  value: ListingSortSlug;
  /** Runs a fresh search for the chosen sort. */
  onChange: (sort: ListingSortSlug) => void;
  /** Extra classes for the wrapping control. */
  className?: string;
  /** Distinguishes the concurrently mounted mobile and desktop instances. */
  analyticsName?: string;
}

const OPTIONS: ComboboxOption[] = listingSortOptions;

export const ListingSortControl = ({
  value,
  onChange,
  className,
  analyticsName,
}: ListingSortControlProps) => (
  <Combobox
    aria-label="Sort homes"
    analyticsName={analyticsName}
    trackImpression={analyticsName != null}
    size="sm"
    placeholder="Sort"
    options={OPTIONS}
    className={className}
    value={OPTIONS.find((option) => option.value === value) ?? null}
    onValueChange={(option) => {
      if (option != null && isListingSortSlug(option.value)) {
        onChange(option.value);
      }
    }}
  />
);
